import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/vendor-request';
import { fetchAllRequestStatus, fetchAllDepartments } from 'actions/utils';
import Loading from 'components/loading';
import RequestTable from 'components/vendor-requests/requests-table';
import { RequestControls } from 'components/vendor-requests/controls';
import { Container, PlainButton } from 'components/styled-components';
import { Link } from 'react-router-dom';
import Permissions from 'utils/permissions';
import hasPermission from 'utils/hasPermission';
import Pagination from 'components/pagination';
import moment from 'moment';
import { HeaderFlexRow, HeadingTitle } from 'components/styled-components';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';
import { fetchAllVendorRequests } from 'api/vendor-request';

function stashParams(params){
	sessionStorage.setItem('vr_params', JSON.stringify(params))
}

function unloadParams(){
	let data = sessionStorage.getItem('vr_params');
	if(typeof data === 'undefined') return {};
	return JSON.parse(data);
}

class ManageVendorRequests extends Component {
  state = {
    query: '',
    filter: '',
    currentPage: 0,
    perPage: 10,
    orderBy: 'vendorRequestID',
    orderDesc: false,
    dateType: '',
    dateCheck: '',
    dateToFilterBy: '',
    displayFilter: this.props.filter ? 'Status' : '',
    field: '',
    exportParams: {},
		sponsors: [],
  };

  componentDidMount() {
		this.loadSponsors();
		let initialState = {};

		if(typeof this.props.location.filterType !== 'undefined'){
			initialState.filter = this.props.location.filter;
			initialState.field = this.props.location.filterType;
			initialState.displayFilter = this.props.location.displayFilter ? this.props.location.displayFilter : (this.props.location.filterAltName ? `Status > ${this.props.location.filterAltName}` : ( this.props.location.filter ? `Status > ${this.props.location.filter}` : '' ))
		}else{
			initialState = unloadParams();
		}

		this.setState(initialState, this.loadRequests);

		///------------------------------------------------

    if (
      hasPermission(this.props.appUser.permissions, [
        'MODIFY_ALL_THIRD_PARTY_REQUESTS',
        'MODIFY_OWNED_THIRD_PARTY_REQUESTS',
      ])
    ) {
      this.props.fetchAllRequestStatus();
      this.props.fetchAllDepartments();
    }
  }

	// doing this here because having to figure out how to get ONLY the sponsors of requests this person has access to to create a separate API is... no
	loadSponsors = () => {
		fetchAllVendorRequests({ start: 0, limit: -1 })
			.then(results => {
				if(typeof results.data.result !== 'undefined' && results.data.result.length > 0){
					let newSponsors = results.data.result.map(vr => vr.sponsorInformation).reduce((accumulator, currentValue) => {
						let me = accumulator.find(acc => acc.userID === currentValue.userID);
						if(typeof me === 'undefined') accumulator.push(currentValue);
						return accumulator;
					},[]);
					this.setState({ sponsors: newSponsors })
				}
			})
	}

	loadRequests = () => {
		// consolidating all the calls to the request action into a single function
		const params = this.buildParams();
    this.setExportParams(params);
		this.props.fetchAllVendorRequests(params);
	}

  setExportParams = params => {
    this.setState({ exportParams: { ...params } });
  };

  buildParams = () => {
    const {
      filter,
      field,
      query,
      dateToFilterBy,
      dateType,
      dateCheck,
      orderBy,
      orderDesc,
			currentPage,
			perPage,
			displayFilter
    } = this.state;
		stashParams({ filter, field, query, dateToFilterBy, dateType, dateCheck, orderBy, orderDesc, currentPage, perPage, displayFilter });
    return {
			start: currentPage * perPage,
			limit: perPage,
      ...(this.props.location.owned && {
        sponsorID: this.props.appUser.userID,
      }),
      ...(query && { searchQuery: query }),
      ...(filter !== '' && {
        [field]: filter,
      }),

      ...(moment(dateToFilterBy).isValid() && {
        date: {
          dateType,
          dateCheck,
          date: moment(dateToFilterBy).format('YYYY-MM-DD'),
        },
      }),
      ...(orderDesc ? { orderBy, orderDir: 'desc' } : { orderBy }),
    };
  };

  handleSearch() {
		// reset page on re-searching
		this.setState({ currentPage: 0 }, this.loadRequests)
  }

  throttledSearch = debounce(
    this.handleSearch,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  handleQueryChange = e => {
    e.preventDefault();
    this.setState(
      { query: e.target.value, currentPage: 0 },
      this.throttledSearch
    );
  };

  handleChangeFilter = (filter, field, displayFilter) => {
		const stateUpdate = {
			// clear our the date filters
			dateType: '',
			dateCheck: '',
			dateToFilterBy: '',
			// set our non-date filter stuff
			displayFilter,
			filter,
			field,
			// reset page on refiltering
			currentPage: 0,
		};
    this.setState(stateUpdate, this.loadRequests);
  };

  clearFilters = () => {
		const stateUpdate = {
      filter: '',
      displayFilter: '',
      dateCheck: '',
      dateType: '',
      dateToFilterBy: '',
			currentPage: 0,
    };
    this.setState(stateUpdate, this.loadRequests);
  };

  handleDateFilterChange = (dateType, dateCheck, filterDate, displayFilter) => {
		const stateUpdate = {
			// clear out our non date filters
			filter: '',
			// set our date filter stuff
			dateType,
			dateCheck,
			dateToFilterBy: filterDate,
			displayFilter: `${displayFilter} ${dateCheck} ${moment(filterDate).format('MM/DD/YYYY')}`,
			// reset page on refiltering
			currentPage: 0,
		};
    this.setState(stateUpdate, this.loadRequests);
  };

  handlePageClick = currentPage => {
		const stateUpdate = { currentPage };
    this.setState(stateUpdate, this.loadRequests);
  };

  handlePerPageChange = perPage => {
		// reset page on changing page size
		const stateUpdate = { perPage: perPage.value, currentPage: 0 };
    this.setState(stateUpdate, this.loadRequests);
  };

  handleOrderByClick = orderBy => {
		const stateUpdate = {
			orderBy,
			orderDesc: this.state.orderBy === orderBy ? !this.state.orderDesc : false // if it was alrady this field, do the opposite, otherwise set to ascending
		};
    this.setState(stateUpdate, this.loadRequests);
  };

  render() {
    const { query, filter } = this.state;
    const { requests, isError, appUser } = this.props;

    if (this.props.isFetching) return <Loading size={200} />;
    return (
      <Container width="100%">
        <HeaderFlexRow>
          <HeadingTitle>Third Party Assessments</HeadingTitle>
          {this.props.appUser.permissions.includes(
            Permissions.CREATE_THIRD_PARTY_REQUESTS
          ) && (
            <Link to="/new">
              <PlainButton>Create Assessment</PlainButton>
            </Link>
          )}
        </HeaderFlexRow>

        <RequestControls
          query={query}
          filter={filter}
          field={this.state.field}
          //TODO: set default value to props.filter onload
          handleSearch={this.handleQueryChange}
          handleChangeFilter={this.handleChangeFilter}
          requests={requests}
          handleDateFilterChange={this.handleDateFilterChange}
          dateType={this.state.dateType}
          dateToFilterBy={this.state.dateToFilterBy}
          dateCheck={this.state.dateCheck}
          filterData={this.props.filters}
          filterDataLoaded={this.props.isFiltersLoaded}
          displayFilter={this.state.displayFilter}
          statusList={this.props.statusFilters}
          departmentList={this.props.departmentFilters}
          clearFilters={this.clearFilters}
          exportParams={this.state.exportParams}
          appUser={appUser}
					sponsors={this.state.sponsors}
        />
        <RequestTable
          requests={typeof requests.result !== 'undefined' && requests.result.length <= this.state.perPage ?requests.result : []}
          totalCount={requests.totalCount}
          handleOrderByClick={this.handleOrderByClick}
          orderBy={this.state.orderBy}
          orderDesc={this.state.orderDesc}
          isError={isError}
          query={this.state.query}
          appUser={appUser}
        />
        <Pagination
          numRecords={requests.totalCount ? requests.totalCount : 0}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  requests: state.vendorRequest.allRequests,
  isFetching: state.vendorRequest.isFetching,
  isError: state.vendorRequest.isErrorAllRequests,
  filters: state.vendorRequest.filters,
  isFiltersLoaded: state.vendorRequest.isFiltersLoaded,
  statusFilters: state.utils.requestStatus,
  departmentFilters: state.utils.departments,
});

ManageVendorRequests = connect(
  mapStateToProps,
  { ...actions, fetchAllRequestStatus, fetchAllDepartments }
)(ManageVendorRequests);

export default ManageVendorRequests;
